import { render, staticRenderFns } from "./TeacherApprovalPage.vue?vue&type=template&id=3d1280aa&scoped=true"
import script from "./TeacherApprovalPage.vue?vue&type=script&lang=js"
export * from "./TeacherApprovalPage.vue?vue&type=script&lang=js"
import style0 from "./TeacherApprovalPage.vue?vue&type=style&index=0&id=3d1280aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1280aa",
  null
  
)

export default component.exports